// @ts-nocheck
import React from "react";
import SendStep from "components/EditDrawer/SendStep/SendStep";
import { t } from "i18next";

export default function UserSendStep(props) {
	const user = props.object;
	const date = Date.now();

	const queries = [
		{
			queryKey: ["SendUser", "Register", date],
			queryFn: () => user.register(),
			title: t("Contacts.SENDING_REGISTER"),
			disabled: !user.isNew(),
			required: true
		},
		{
			queryKey: ["SendUser", date],
			queryFn: () => user.send(),
			title: t("Contacts.SENDING_INFOS"),
			required: true
		},
		{
			queryKey: ["SendUser", "MailConfirm", date],
			queryFn: () => user.sendConfirmMail(),
			title: t("Contacts.SENDING_CONFIRM_MAIL"),
			disabled: !user.isNew(),
			required: true
		},
		{
			queryKey: ["SendUser", "Groups", date],
			queryFn: () => user.sendGroups(),
			title: t("Contacts.SENDING_GROUPS"),
			disabled: !user.linkedGroups()?.length && !user.groupsToLink()?.length
		},
		// {
		// 	queryKey: ["SendUser", "Rights", date],
		// 	queryFn: () => user.sendRights(),
		// 	title: "Gestion des droits",
		// },
		{
			queryKey: ["SendUser", "Image", date],
			queryFn: () => user.sendImage(),
			title: t("Contacts.SENDING_IMAGE"),
			disabled: !user.image()
		}
	];

	if (!props.isActive)
		return (false);

	return (
		<SendStep
			queries={queries}
			instance={props.instance}
			isDone={props.isDone}
			setIsDone={props.setIsDone}
			setFailedStep={props.setFailedStep}
		/>
	);
}
